import React from "react";

const HeroPattern = () => (
  <div className="hero-pattern" aria-hidden="true">
    <svg
      width="100%"
      height="100%"
      preserveAspectRatio="xMidYMid slice"
      xmlns="http://www.w3.org/2000/svg"
    >
      <svg x="6%" y="22%" overflow="visible">
        <use
          href="#faq-blob-1"
          fill="#FFA5BC"
          transform="scale(2.2)"
          opacity="0.16"
        />
      </svg>
      <svg x="84%" y="76%" overflow="visible">
        <use
          href="#faq-blob-2"
          fill="#B798F2"
          transform="scale(2.6)"
          opacity="0.14"
        />
      </svg>
      <svg x="50%" y="-15%" overflow="visible">
        <use
          href="#faq-blob-3"
          fill="#E8EBFF"
          transform="scale(2.0)"
          opacity="0.50"
        />
      </svg>
      <svg x="68%" y="58%" overflow="visible">
        <use
          href="#faq-blob-1"
          fill="#F3EC7A"
          transform="scale(1.2)"
          opacity="0.30"
        />
      </svg>
    </svg>
  </div>
);

const Hero = () => (
  <header className="hero">
    <HeroPattern />
    <div className="container">
      <span className="eyebrow">Frequently asked</span>
      <h1 className="hero-title">
        The questions people <em>actually ask</em>.
      </h1>
      <p className="hero-sub">
        Honest answers in plain English. <strong>No marketing fluff.</strong> If
        we don't cover yours, the human at the bottom of this page will.
      </p>
    </div>
  </header>
);

export default Hero;
